<template>
  <el-form
    ref="form"
    :model="value"
    :rules="rules"
    :label-width="labelWidth"
    size="small"
    v-bind="$attrs"
  >
    <el-form-item
      v-for="(item, index) in formItems"
      :key="index"
      :label="item.label"
      :prop="item.prop"
      v-show="show(item, value)"
    >
      <component
        v-if="item.component"
        :is="$getComponent(item.component)"
        v-model="value[item.prop]"
        :form-value="value"
        v-bind="item.bind"
        v-on="item.on"
        ref="items"
      ></component>
      <el-input
        v-else
        v-model="value[item.prop]"
        v-bind="item.bind"
        v-on="item.on"
        @blur="inputBlur(item.prop)"
        @keydown.enter.native="inputBlur(item.prop)"
        ref="items"
        autocomplete="off"
        size="small"
      ></el-input>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'base-form', //兼容新组件名称定义
  props: {
    formItems: Array,
    rules: Object,
    value: Object,
    inputTrim: {
      type: Boolean,
      default: false,
    },
    labelWidth: String,
    initValue: {
      type: Boolean,
      default: true,
    },
    // defaultPlaceholder: {
    //   type: String,
    //   default() {
    //     switch (this.$lang) {
    //       case 'en':
    //         return 'Please select'
    //       default:
    //         return '请输入'
    //     }
    //   },
    // },
  },
  created() {
    if (this.initValue) {
      this.$initFormItems(this.value, this.formItems, true)
    }
  },
  updated() {
    for (var index in this.formItems) {
      this.formItems[index].$this = this.items[index]
    }
  },
  data() {
    return {
      watch: {
        value: false,
        formItems: false,
      },
    }
  },
  methods: {
    validate(callback) {
      this.$refs.form.validate(callback)
    },
    validateField(props, callback) {
      this.$refs.form.validateField(props, callback)
    },
    resetFields() {
      this.$refs.form.resetFields()
    },
    clearValidate(props) {
      this.$refs.form.clearValidate(props)
    },
    show(item, value) {
      if (typeof item.show == 'function') {
        return item.show.call(this, item, value)
      }
      return true
    },
    inputBlur(prop) {
      if (this.value && this.inputTrim) {
        this.$set(this.value, prop, this.$trim(this.value[prop]))
      }
    },
  },
  computed: {
    items() {
      return this.$refs.items
    },
  },
  watch: {
    // formItems: {
    //   //监听formItems变化，以便实时更新value
    //   handler(newVal, oldVal) {
    //     // console.log('watch.formItems', JSON.stringify(newVal))
    //     if (this.watch.value) return
    //     this.watch.formItems = true
    //     this.$initFormItems(this.value, newVal, true)
    //     this.watch.formItems = false
    //   },
    //   deep: true,
    // },
    value: {
      handler(newVal, oldVal) {
        // console.log('watch.value', JSON.stringify(newVal))
        if (this.watch.formItems) return
        this.watch.value = true

        this.$setFormItems(newVal, this.formItems, true)
        // console.log('watch.value', JSON.stringify(newVal))
        this.$emit('change', newVal)
        this.watch.value = false
      },
      deep: true,
    },
  },
}
</script>

<style>
</style>
